import React, { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const navState = useMemo(() => ({ from: location }), [location]);

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center" data-testid="protected-loading">
        <div className="font-mono-ll tracking-widest text-sm text-[#64748B]">LOADING…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={navState} replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  return children;
}
